
<div>
    <d-contract-zus-edit
        v-model      = "edit"
        :contract-id = "contract ? contract.id : null"
        :company-id  = "contract && contract.company ? contract.company.id : null"
        @saved       = "onSaved"
    />

    <c-list-card
        :icon       = "icon"
        :background = "background"
        :height     = "107"
        @edit       = "onEdit"
        @selected   = "onSelect"
    >
        <template v-slot:title>
            <div>
                <span class="primary--text">
                    {{ contract.id }} - {{ date (contract.start) }} bis {{ date (contract.expiration) }}
                </span>
            </div>
            <v-spacer></v-spacer>
            <company-tag
                :label   = "$t('msd.service.role.srv.label')"
                :active  ="contract.active"
                :company = "contract.company"
            />
        </template>

        <template v-slot:subtitle>
            {{ contract.customer.name }}
        </template>

        <template v-slot:body>
            <p-contract-condition
                class="mt-2"
                :contract = "contract"
            />
        </template>

    </c-list-card>
</div>
